import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Spinner } from "../../../components/Layout";
import AvisLoadBuildForm from "../../formControl/avisForm";
import DirectionsBoatFilledRoundedIcon from '@mui/icons-material/DirectionsBoatFilledRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import { log } from "../../../Helper";
import { Button } from "@deere/fuel-react";
const AvisPageDialog = (props) => {
  const {
    open,
    handleClose,
    handleApply,
    openDeleteSO,
    handleCloseDeleteSO,
    selectedMachinesForDeleteSO,
    handleDeleteSOYes,
    selectedMachinesForBuild,
    imoList,
    locationList,
    openLoader,
    handleCloseLoader,
    uniqueTruckDetailsDTOList,
  } = props;
  const transportMode = selectedMachinesForBuild?.transportMode;
  return (
    <>
      <div id="avis-dialog-div1" className=" w-[40%]">
        <Dialog
          id="avis-dialog1"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title">
            {(transportMode === "VESSEL" || transportMode === "FERRY") ? (
              <DirectionsBoatFilledRoundedIcon className="mr-1 text-green-700" />
            ) : (
              <LocalShippingRoundedIcon className="mr-1 text-green-700" />
            )}
            {`Update Load build & Pick Up `}
          </DialogTitle>
          <DialogContent id="avis-dialog-content1">
            <AvisLoadBuildForm 
            selectedMachinesForBuildProp={selectedMachinesForBuild}
            uniqueTruckDetailsDTOList={uniqueTruckDetailsDTOList}
            imoList={imoList}
            locationList={locationList}
            />
          </DialogContent>
          <DialogActions id="avis-dialog-actions1" style={{ justifyContent: "center" }}>
            <Button
              id="avis-apply-btn"
              variant="primary"
              onClick={() => handleApply(selectedMachinesForBuild)}
            >
              Apply
            </Button>
            <Button
              id="avis-cancel-btn"
              variant="secondary"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div id="avis-dialog-div2" className=" w-[40%]">
        <Dialog
          id="avis-dialog2"
          open={openDeleteSO}
          onClose={handleCloseDeleteSO}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title2">
            {"Delete Shipping Order"}
          </DialogTitle>
          <DialogContent id="avis-dialog-content2">
            {"Do you want to delete shipping order "}{" "}
            {selectedMachinesForDeleteSO.shpOrder} {"?"}
          </DialogContent>
          <DialogActions id="avis-dialog-actions2" className=" justify-center">
            <Button
              id="avis-dialog-delete-so-yes"
              variant="primary"
              onClick={() => handleDeleteSOYes(selectedMachinesForBuild)}
            >
              Yes
            </Button>
            <Button
              id="avis-dialog-delete-so-no"
              variant="secondary"
              onClick={handleCloseDeleteSO}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <div id="avis-dialog-div3">
        <Dialog
          id="avis-dialog3"
          open={openLoader}
          onClose={handleCloseLoader}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth
        >
          <DialogTitle id="alert-dialog-title3"></DialogTitle>
          <DialogContent id="avis-dialog-content3">
            <div id="avis-dialog-spinner" className="d-flex w-100 justify-content-center align-items-center">
              <Spinner
                accessibilityLabel="Loading"
                className="uxf-spinner-border-lg"
                animation="border"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default AvisPageDialog;